import de from './de.json';
import fr from './fr.json';
import it from './it.json';

export interface TranslationTable {
  errors: Record<string, string>;
  labels: Record<string, string>;
}

const translationMap: Record<string, TranslationTable> = {
  de,
  fr,
  it
};

export function getTranslation(lang: string | null | undefined): TranslationTable {
  if (lang && lang in translationMap) {
    return translationMap[lang];
  }
  return translationMap['de']; // fallback
}
